import axios from 'axios';
import { userActivityType } from '../../../interfaces/User.interfaces';
import { customAxios } from '../../common/customAxios';

export const postUserActivityTracking = (activityType: userActivityType) => {
  return customAxios.post('/user-activity-tracking', {
    activityType,
  });
};
